export default "__VITE_ASSET__9a9b16aa__"